import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Popover, { PopoverAnimationVertical } from 'components/ContextPopover';
import accepts from 'attr-accept';
import PropTypes from 'prop-types';

import { DocumentActions, EntityListActions } from 'actions';
import {
    PopOverCellAddDocument,
    PopOverCellAddLink,
    PopOverCellAddFolder,
    PopOverCellEdit,
    PopOverCellDelete,
    PopOverCellShare,
    PopOverCellDownload,
    PopOverCellOpen,
} from 'components/popovers';

import './DocumentsPopOver.scss';

const propTypes = {
    folderSelected: PropTypes.object,
    targetElement: PropTypes.object,
    onRequestClose: PropTypes.func,
    canCreateDocument: PropTypes.bool,
    canEditDocument: PropTypes.bool,
    canDeleteDocument: PropTypes.bool,
    canCreateFolder: PropTypes.bool,
    canEditFolder: PropTypes.bool,
    canDeleteFolder: PropTypes.bool,
    showCreateFolder: PropTypes.func,
    showLinkAction: PropTypes.func,
    showDeleteFolder: PropTypes.func,
    downloadDocument: PropTypes.func,
    downloadDocumentLink: PropTypes.func,
    addMultipleDocumentsToUpload: PropTypes.func,
};

const mapStateToProps = (state) => {
    let permission = state.config.permission;
    let documentPermission = permission.crud_permission.DOCUMENT;
    let folderPermission = permission.crud_permission.DOCUMENTLIBRARY;
    return {
        canCreateDocument: permission.documentos_manager && documentPermission.create,
        canEditDocument: permission.documentos_manager && documentPermission.update,
        canDeleteDocument: permission.documentos_manager && documentPermission.delete,
        canCreateFolder: permission.documentos_manager && folderPermission.create,
        canEditFolder: permission.documentos_manager && folderPermission.update,
        canDeleteFolder: permission.documentos_manager && folderPermission.delete,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        showCreateFolder: bindActionCreators(DocumentActions, dispatch).showCreateFolder,
        showLinkAction: bindActionCreators(DocumentActions, dispatch).showLinkAction,
        showDeleteFolder: bindActionCreators(DocumentActions, dispatch).showDeleteFolder,
        downloadDocument: bindActionCreators(DocumentActions, dispatch).downloadDocument,
        downloadDocumentLink: bindActionCreators(DocumentActions, dispatch).downloadDocumentLink,
        addMultipleDocumentsToUpload: bindActionCreators(DocumentActions, dispatch)
            .addMultipleDocumentsToUpload,
        init: bindActionCreators(EntityListActions, dispatch).init,
    };
};

@connect(mapStateToProps, mapDispatchToProps)
class DocumentsAddPopOver extends Component {
    handleOpenDialogAddFolder = () => {
        return () => {
            let { showCreateFolder, folderSelected, onRequestClose, entityType } = this.props;

            const currentFolderId = folderSelected.id;
            const crudAction = 'create';
            const elementType = 'folder';
            showCreateFolder(true, currentFolderId);

            onRequestClose && onRequestClose();
        };
    };

    handleOpenDialogAddLink = () => {
        return () => {
            let { showLinkAction, onRequestClose } = this.props;
            showLinkAction(true);
            onRequestClose && onRequestClose();
        };
    };

    handleOpenAddDocument = () => {
        return () => {
            let { onRequestClose } = this.props;
            this.openPopOver();
            onRequestClose && onRequestClose();
        };
    };

    handleOpenDialogEdit = () => {
        return () => {
            const { showCreateFolder, onRequestClose, currentElement, entityType } = this.props;

            const crudAction = 'update';
            const elementType = 'document';

            showCreateFolder(
                true,
                currentElement.node_id,
                entityType,
                currentElement,
                crudAction,
                elementType,
            );
            onRequestClose && onRequestClose();
        };
    };

    handleOpenDialogShareDocument = () => {
        return () => {
            const { downloadDocumentLink, currentElement, onRequestClose } = this.props;

            downloadDocumentLink(currentElement);
            onRequestClose && onRequestClose();
        };
    };

    handleOpenDialogDelete = () => {
        return () => {
            const { currentElement, showDeleteFolder, entityType, onRequestClose } = this.props;

            showDeleteFolder(true, entityType, currentElement);
            onRequestClose && onRequestClose();
        };
    };

    handleDownload = () => {
        return () => {
            const { downloadDocument, currentElement, onRequestClose } = this.props;
            downloadDocument(currentElement);
            onRequestClose && onRequestClose();
        };
    };

    handleOpenLink = () => {
        return () => {
            const { currentElement, onRequestClose } = this.props;

            window.open(currentElement.link, '_blank');
            onRequestClose && onRequestClose();
        };
    };

    openPopOver = () => {
        if (this.fileInputEl) {
            this.fileInputEl.value = null;
            this.fileInputEl.click();
        }
    };

    onSelectFile = (event) => {
        event.preventDefault();

        // Reset the counter along with the drag on a drop.
        this.enterCounter = 0;

        this.setState({
            isDragActive: false,
            isDragReject: false,
        });

        const droppedFiles = event.dataTransfer ? event.dataTransfer.files : event.target.files;
        const max = droppedFiles.length;
        const files = [];

        for (let i = 0; i < max; i++) {
            const file = droppedFiles[i];
            file.preview = window.URL.createObjectURL(file);
            files.push(file);
        }

        if (this.allFilesAccepted(files)) {
            if (this.uploadFile) {
                this.uploadFile(files, event);
            }
        }
    };

    allFilesAccepted(files) {
        return files.every((file) => accepts(file, this.props.accept));
    }

    uploadFile = (files) => {
        const { addMultipleDocumentsToUpload, onRequestClose, entityType, folderSelected, init } =
            this.props;

        addMultipleDocumentsToUpload(files, folderSelected.id, entityType.entity).then(() => {
            init(entityType, false, null, null, null, true);
        });
        onRequestClose && onRequestClose();
    };

    render() {
        let {
            onRequestClose,
            open,
            anchorEl,
            canCreateDocument,
            canCreateFolder,
            canEditDocument,
            canEditFolder,
            canDeleteFolder,
            canDeleteDocument,
            folderSelected,
            currentElement,
            cells,
        } = this.props;

        const targetElement = folderSelected ? folderSelected : currentElement;

        let canEdit = false;
        //let actionEdit;
        if (targetElement?.is_folder === '1' && canEditFolder) {
            canEdit = true;
            //actionEdit = this.handleOpenDialogEditFolder;
        }
        if (targetElement?.is_folder === '0' && canEditDocument) {
            canEdit = true;
            //actionEdit = this.handleOpenDialogEditDocument;
        }

        let canDelete = false;

        if (targetElement?.is_folder === '1' && canDeleteFolder) {
            canDelete = true;
        }
        if (targetElement?.is_folder === '0' && canDeleteDocument) {
            canDelete = true;
        }

        const canDownload =
            targetElement?.is_folder === '0' && targetElement.is_link === '0' ? true : false;
        const canShare = (targetElement === 'is_folder') !== '1' ? true : false;

        const cellsObj = {
            addDocument: (
                <PopOverCellAddDocument
                    enabled={canCreateDocument}
                    permission={canCreateDocument}
                    handleOnClick={this.handleOpenAddDocument}
                />
            ),
            addLink: (
                <PopOverCellAddLink
                    enabled={canCreateDocument}
                    permission={canCreateDocument}
                    handleOnClick={this.handleOpenDialogAddLink}
                />
            ),
            addFolder: (
                <PopOverCellAddFolder
                    enabled={canCreateFolder}
                    permission={canCreateFolder}
                    handleOnClick={this.handleOpenDialogAddFolder}
                />
            ),
            edit: (
                <PopOverCellEdit
                    enabled={canEdit}
                    permission={canEdit}
                    handleOnClick={this.handleOpenDialogEdit}
                />
            ),
            delete: (
                <PopOverCellDelete
                    enabled={canDelete}
                    permission={canDelete}
                    handleOnClick={this.handleOpenDialogDelete}
                />
            ),
            share: (
                <PopOverCellShare
                    enabled={canShare}
                    permission={canShare}
                    handleOnClick={this.handleOpenDialogShareDocument}
                />
            ),
            download: (
                <PopOverCellDownload
                    enabled={canDownload}
                    permission={canDownload}
                    handleOnClick={this.handleDownload}
                />
            ),
            open: (
                <PopOverCellOpen
                    enabled={true}
                    permission={true}
                    handleOnClick={this.handleOpenLink}
                />
            ),
        };

        const renderPopOverCells =
            cells &&
            cells.length > 0 &&
            cells.map((current, index) => {
                if (cellsObj[current]) {
                    return <div key={index}>{cellsObj[current]}</div>;
                }
            });

        return (
            <span>
                <Popover
                    className="documents-popover"
                    open={open}
                    anchorEl={anchorEl}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    targetOrigin={{ horizontal: 'right', vertical: 'top' }}
                    onRequestClose={onRequestClose}
                    animation={PopoverAnimationVertical}
                >
                    <div className="documents-popover-cells-container">{renderPopOverCells}</div>
                </Popover>
                <input
                    style={{ display: 'none' }}
                    type={'file'}
                    multiple={true}
                    ref={(el) => (this.fileInputEl = el)}
                    onChange={this.onSelectFile}
                />
            </span>
        );
    }
}

DocumentsAddPopOver.propTypes = propTypes;

export default DocumentsAddPopOver;
